interface LogoProps {
  className?: string;
}

export default function Logo({ className }: LogoProps) {
  return (
    <svg
      viewBox="0 0 1600 633.3"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Imagination Media logo"
    >
      <path
        fill="currentColor"
        d="M1600,571.2c-38.5,44.6-84,59.7-130.1,56.2c-55.3-4.3-88-20.5-116.2-70.5c-53.3-94.7-172.4-300.2-172.4-300.2c-16.7-32.5-43.8-50.5-77.1-41.1c-26.7,7.5-37.8,29.8-40.7,41.6c-5.8,23.7,4.3,45.1,21.6,71.5l140.8,245.8c-25.7,48.7-82.6,61.6-128.7,58.2c-55.3-4.3-88-20.5-116.2-70.5c-53.3-94.7-175.4-305.8-175.4-305.8c-17.4-35.3-42-49.5-76.4-40c-30.7,8.5-41.1,36.3-41.2,56.3c0,13,7.1,25.2,13.7,36.4l149.6,261.1l2.5,4.6c-27.4,46.7-82.6,59.7-129.4,58.4c-55.4-1.5-88-20.5-116.2-70.6c-53.3-94.6-172.5-300.2-172.5-300.2C415.9,223,396.2,210.8,368,214c-38.9,4.4-53.4,38-51.6,62.3c0.6,8.9,3.5,17.5,7.8,25.1c36,62.3,66.6,115,102.5,177.5l55.6,96.1c-34.4,41.7-85.3,60.3-131.9,58.3c-39.8-1.8-87.3-22.4-105.2-54C185.7,474.9,84.6,302,20.8,192c-8.2-18-18.2-46.4-20-71.5C-5,45.3,75.6-15.5,147.1,12.4c41.6,15.3,71.4,55.3,71.4,102.3c0,30.8-11.6,56.4-32.7,75.6c-11,10-30.5,16.9-48.3,17.6c-13.8,0.5-23.8-2.6-31.7-6.8c22.9,16.2,43.8,19,70.2,19c35.1,0,56.7-7.1,85.6-29.2c4.5-3.9,44.4-24.8,68.9-107.6c26.6-101.3,172.6-109.2,245.6,8.2c17.7,28.6,48.3,82.9,58.2,100c35.2,0,36.2-41,45.8-104.1c20.2-102.6,195.3-116.8,267,4.1c17.5,29.5,49,82.2,59.4,99.4c39.6,0,38.3-59.7,51.2-116.3c31.1-98.4,198.3-104.1,263.7,11c55.1,97,60.5,104.2,102.6,177L1596,564.3l3.9,6.8L1600,571.2z"
      />
    </svg>
  );
}
